import { Map } from "leaflet";

import { useStudyArea } from "hooks/studyAreaHooks";

import { ClimateEffectsDrawerContent } from "components/drawerContent/ClimateEffectsDrawerContent";
import { useConfigParameters } from "hooks/configParametersHooks";

interface Props {
  uuid: string;
  mapRef: Map;
  footerRef: HTMLDivElement;
}
export function ClimateEffectsPageLoader(props: Props) {
  const { uuid, mapRef, footerRef } = props;
  const { data: studyArea } = useStudyArea(uuid);
  const { data: config } = useConfigParameters();

  return (
    <>
      {studyArea && config && (
        <ClimateEffectsDrawerContent
          mapRef={mapRef}
          footerRef={footerRef}
          studyArea={studyArea}
          uuid={uuid}
          climateRiskLevels={config.climateRiskLevels}
        />
      )}
    </>
  );
}
